$(function () {
  var ww = $(window).width();  
  
  $('#indexAboutSection .sectionBox .textBox .showMore').bind('click',function(){
    $(this).hasClass("active") ? $(this).text("Read More >").removeClass("active") : $(this).text("See less >").addClass("active");
    $("#indexAboutSection .sectionBox .textBox .text").toggleClass("show")
  });

  
  if(ww>=1000){
    $(".index-plus-size-section .textConBox .text a").hover(function () {
      var _data = $(this).attr("data-name");
      var _parent = $(this).parent().parent("div.text");
      $(".index-plus-size-section .imageSwitchBox .image").removeClass("active");
      $(".index-plus-size-section .imageSwitchBox .image[data-name="+_data+"]").addClass("active");
      $(".index-plus-size-section .textConBox .text a").removeClass("active");
      $(this).addClass("active");
      _parent.addClass("on");
      _parent.find(".description").slideDown()
    },function () {
      var _parent = $(this).parent().parent("div.text");
      _parent.removeClass("on");
      _parent.find(".description").slideUp()
    })
  }else{
    $('.index-plus-size-section .imageSwitchBox').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      touchMove: false,
      asNavFor: '.index-plus-size-section .textBox'
    });
    $('.index-plus-size-section .textBox').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.index-plus-size-section .imageSwitchBox',
      dots: true,
      touchMove: false,
      focusOnSelect: true
    });
  }

  $('.text__category__slick').slick({
    dots: true,
    arrows: false,
    touchMove: false,
    speed: 1000,
    rows: 2,
    slidesToShow: 2,
    slidesToScroll: 2
  });

  // index Review
  $('.indexReviewSlick').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  
  // index advertise
  $('.advertiseSlick').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 2,
    slidesToScroll: 1
  });

  $(".instagram_tiktok_content .btn").click(function () {
    var _data = $(this).attr("data-name");
    $(".instagram_tiktok_content .btn").removeClass("active");
    $(this).addClass("active");
    $(".instagram_tiktok_content .box").removeClass("active");
    $(".instagram_tiktok_content .box[data-name="+_data+"]").addClass("active");
  })
});

$(function () {
  var imageWithTextSwiper = new Swiper ('.more-image-with-text-box', {
    scrollbar: '.swiper-scrollbar',
    effect: 'fade',
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });
  $('.more-image-with-text-box').hover(function(){
    imageWithTextSwiper.autoplay.stop();
  },function(){
    imageWithTextSwiper.autoplay.start();
  })

});

// index Color items
$(function () {
  var color_Swiper = new Swiper ('.item-scroll-box', {
    slidesPerView: 15,
    freeMode: true,
    scrollbar: '.swiper-scrollbar',
    breakpoints: {
      1400: {
        slidesPerView: 13,
      },
      1200: {
        slidesPerView: 10,
      },
      999: {
        slidesPerView: 8,
      },
      740: {
        slidesPerView: 6,
      },
      540: {
        slidesPerView: 6,
      },
      320: {
        slidesPerView: 4,
      }
    }
  });
  $('#color-items .item').on('mouseenter', function() {
    var $this = $(this);
    var $img = $this.find('.color_image');
    var $poa = $this.find('.poa');
    var $list = $poa.find('.list');

    if ($list.length <= 0) {
      $poa.remove();
      $this.addClass("no-poa");
    }

    $poa.show();
    $this.addClass("active");
    $('#color-items .item').not($this).find('.color_image').css({ width: '70px', height: '70px' });
    $img.css({ width: '80px', height: '80px' });

    var $prevItem = $this.prev('.item');
    var $nextItem = $this.next('.item');
        
    if ($prevItem.length) $prevItem.find('.color_image').css({ width: '75px', height: '75px' });
    if ($nextItem.length) $nextItem.find('.color_image').css({ width: '75px', height: '75px' });

    if ($this.is(':first-child')) $poa.css({ left: '0', right: 'auto', transform: 'translateX(0)' });
    else if ($this.is(':last-child')) $poa.css({ left: 'auto', right: '0', transform: 'translateX(0)' });
    else $poa.css({ left: '50%', transform: 'translateX(-50%)' });
  })
  $('#color-items .item').on('mouseleave', function() {
    var $this = $(this);
    var $img = $this.find('.color_image');
    var $poa = $this.find('.poa');

    $poa.hide();
    $this.removeClass("active");
    $img.css({ width: '70px', height: '70px' });

    var $prevItem = $this.prev('.item');
    var $nextItem = $this.next('.item');
        
    if ($prevItem.length) $prevItem.find('.color_image').css({ width: '70px', height: '70px' });
    if ($nextItem.length) $nextItem.find('.color_image').css({ width: '70px', height: '70px' });
  })
})